/** Production origin used for canonical URLs and the sitemap. */
export const SITE_URL = "https://leadershipedge.live";
